/* MENU ITEM FORMS */
export const MENU_ITEM_FORM_GET = "MENU_ITEM_FORM_GET"
export const MENU_ITEM_FORM_SUBMIT = "MENU_ITEM_FORM_SUBMIT"
export const MENU_ITEM_FORM_GET_SUCCESS = "MENU_ITEM_FORM_GET_SUCCESS"
export const MENU_ITEM_FORM_GET_ERROR = "MENU_ITEM_FORM_GET_ERROR"
export const INITIAL_MENU_ITEM_FORM_GET_SUCCESS =
  "INITIAL_MENU_ITEM_FORM_GET_SUCCESS"
export const RELOAD_ENTITIES = "RELOAD_ENTITIES"
export const RELOAD_ENTITIES_SUCCESS = "RELOAD_ENTITIES_SUCCESS"
